import Swal from "sweetalert2";

export default {
  namespaced: true,
  state: {
    // Group Sessions
    groupSessions: {
      loading: false,
      data: [],
      pagination: {
        currentPage: 1,
        lastPage: 1,
        perPage: 15,
        total: 0,
      },
    },
    groupSession: null,
    groupSessionLoading: false,
    createGroupSessionLoading: false,
    updateGroupSessionLoading: false,
    deleteGroupSessionLoading: null,

    // Participants
    participants: {
      loading: false,
      data: [],
    },
    addParticipantsLoading: false,
    removeParticipantLoading: null,

    // Workflow
    verifyLoading: false,
    unverifyLoading: false,
    updateHiddenLoading: false,

    // Attendance
    attendanceLoading: false,

    // Reports
    billingReportData: {
      loading: false,
      data: [],
    },
    payrollReportData: {
      loading: false,
      data: [],
    },
    attendanceReportData: {
      loading: false,
      data: [],
    },
  },
  mutations: {
    // Group Sessions
    SET_GROUP_SESSIONS_LOADING: function (state, payload) {
      state.groupSessions.loading = payload;
    },
    SET_GROUP_SESSIONS_DATA: function (state, payload) {
      state.groupSessions.data = payload;
    },
    SET_GROUP_SESSIONS_PAGINATION: function (state, payload) {
      state.groupSessions.pagination = {
        currentPage: payload.current_page || 1,
        lastPage: payload.last_page || 1,
        perPage: payload.per_page || 15,
        total: payload.total || 0,
      };
    },
    SET_GROUP_SESSION: function (state, payload) {
      state.groupSession = payload;
    },
    SET_GROUP_SESSION_LOADING: function (state, payload) {
      state.groupSessionLoading = payload;
    },
    SET_CREATE_GROUP_SESSION_LOADING: function (state, payload) {
      state.createGroupSessionLoading = payload;
    },
    SET_UPDATE_GROUP_SESSION_LOADING: function (state, payload) {
      state.updateGroupSessionLoading = payload;
    },
    SET_DELETE_GROUP_SESSION_LOADING: function (state, payload) {
      state.deleteGroupSessionLoading = payload;
    },

    // Participants
    SET_PARTICIPANTS_LOADING: function (state, payload) {
      state.participants.loading = payload;
    },
    SET_PARTICIPANTS_DATA: function (state, payload) {
      state.participants.data = payload;
    },
    SET_ADD_PARTICIPANTS_LOADING: function (state, payload) {
      state.addParticipantsLoading = payload;
    },
    SET_REMOVE_PARTICIPANT_LOADING: function (state, payload) {
      state.removeParticipantLoading = payload;
    },

    // Workflow
    SET_VERIFY_LOADING: function (state, payload) {
      state.verifyLoading = payload;
    },
    SET_UNVERIFY_LOADING: function (state, payload) {
      state.unverifyLoading = payload;
    },
    SET_UPDATE_HIDDEN_LOADING: function (state, payload) {
      state.updateHiddenLoading = payload;
    },

    // Attendance
    SET_ATTENDANCE_LOADING: function (state, payload) {
      state.attendanceLoading = payload;
    },

    // Reports
    SET_BILLING_REPORT_DATA_LOADING: function (state, payload) {
      state.billingReportData.loading = payload;
    },
    SET_BILLING_REPORT_DATA: function (state, payload) {
      state.billingReportData.data = payload;
    },
    SET_PAYROLL_REPORT_DATA_LOADING: function (state, payload) {
      state.payrollReportData.loading = payload;
    },
    SET_PAYROLL_REPORT_DATA: function (state, payload) {
      state.payrollReportData.data = payload;
    },
    SET_ATTENDANCE_REPORT_DATA_LOADING: function (state, payload) {
      state.attendanceReportData.loading = payload;
    },
    SET_ATTENDANCE_REPORT_DATA: function (state, payload) {
      state.attendanceReportData.data = payload;
    },
  },
  actions: {
    getGroupSessions: function ({ commit }, payload) {
      const vm = this;
      commit("SET_GROUP_SESSIONS_LOADING", true);
      const filters = [];
      if (payload) {
        if (payload.programId) {
          filters.push(`program_id=${payload.programId}`);
        }
        if (payload.status) {
          filters.push(`status=${payload.status}`);
        }
        if (payload.providerId) {
          filters.push(`provider_id=${payload.providerId}`);
        }
        if (payload.dateFrom || payload.startDate) {
          filters.push(`date_from=${payload.dateFrom || payload.startDate}`);
        }
        if (payload.dateTo || payload.endDate) {
          filters.push(`date_to=${payload.dateTo || payload.endDate}`);
        }
        if (payload.page) {
          filters.push(`page=${payload.page}`);
        }
        if (payload.limit) {
          filters.push(`limit=${payload.limit}`);
        }
      }
      let url = `group-sessions`;
      if (filters.length) {
        url += `?${filters.join("&")}`;
      }
      return new Promise((resolve) => {
        return vm.$http.get(url).then(
          (res) => {
            commit("SET_GROUP_SESSIONS_DATA", res.data.data);
            if (res.data.meta) {
              commit("SET_GROUP_SESSIONS_PAGINATION", res.data.meta);
            }
            commit("SET_GROUP_SESSIONS_LOADING", false);
            resolve(res.data.data);
          },
          (err) => {
            commit("SET_GROUP_SESSIONS_LOADING", false);
            if (!err.accessDenied) {
              Swal.fire({
                title: "Error",
                text:
                  err?.data?.error?.message ||
                  err?.data?.message ||
                  "Something went wrong...",
                icon: "error",
              });
            }
            resolve(false);
          }
        );
      });
    },

    getGroupSession: function ({ commit }, sessionId) {
      const vm = this;
      commit("SET_GROUP_SESSION_LOADING", true);
      return new Promise((resolve) => {
        return vm.$http.get(`group-sessions/${sessionId}`).then(
          (res) => {
            commit("SET_GROUP_SESSION", res.data.data);
            commit("SET_GROUP_SESSION_LOADING", false);
            resolve(res.data?.data);
          },
          (err) => {
            commit("SET_GROUP_SESSION_LOADING", false);
            if (!err.accessDenied) {
              let errorMessage = "Something went wrong...";

              if (err?.status === 404) {
                errorMessage =
                  "The session you are looking for does not exist or has been deleted.";
              } else {
                errorMessage =
                  err?.data?.error?.message ||
                  err?.data?.message ||
                  "Something went wrong...";
              }

              Swal.fire({
                title: "Error",
                text: errorMessage,
                icon: "error",
              });
            }
            resolve(false);
          }
        );
      });
    },

    createGroupSession: function ({ commit }, payload) {
      const vm = this;
      commit("SET_CREATE_GROUP_SESSION_LOADING", true);
      return new Promise((resolve) => {
        return vm.$http.post(`group-sessions`, payload).then(
          (res) => {
            commit("SET_CREATE_GROUP_SESSION_LOADING", false);
            resolve(res.data?.data);
          },
          (err) => {
            commit("SET_CREATE_GROUP_SESSION_LOADING", false);
            if (!err.accessDenied) {
              Swal.fire({
                title: "Error",
                text:
                  err?.data?.error?.message ||
                  err?.data?.message ||
                  "Something went wrong...",
                icon: "error",
              });
            }
            resolve(false);
          }
        );
      });
    },

    updateGroupSession: function ({ commit }, payload) {
      const vm = this;
      commit("SET_UPDATE_GROUP_SESSION_LOADING", true);
      return new Promise((resolve) => {
        return vm.$http.put(`group-sessions/${payload.id}`, payload).then(
          (res) => {
            commit("SET_UPDATE_GROUP_SESSION_LOADING", false);
            resolve(res.data?.data);
          },
          (err) => {
            commit("SET_UPDATE_GROUP_SESSION_LOADING", false);
            if (!err.accessDenied) {
              Swal.fire({
                title: "Error",
                text:
                  err?.data?.error?.message ||
                  err?.data?.message ||
                  "Something went wrong...",
                icon: "error",
              });
            }
            resolve(false);
          }
        );
      });
    },

    deleteGroupSession: function (
      { commit },
      { sessionId, sendNotification = false }
    ) {
      const vm = this;
      commit("SET_DELETE_GROUP_SESSION_LOADING", sessionId);
      return new Promise((resolve) => {
        return vm.$http
          .delete(
            `group-sessions/${sessionId}?send_notification=${
              sendNotification ? 1 : 0
            }`
          )
          .then(
            () => {
              commit("SET_DELETE_GROUP_SESSION_LOADING", null);
              resolve(true);
            },
            (err) => {
              commit("SET_DELETE_GROUP_SESSION_LOADING", null);
              if (!err.accessDenied) {
                Swal.fire({
                  title: "Error",
                  text:
                    err?.data?.error?.message ||
                    err?.data?.message ||
                    "Something went wrong...",
                  icon: "error",
                });
              }
              resolve(false);
            }
          );
      });
    },

    verifySession: function ({ commit }, sessionId) {
      const vm = this;
      commit("SET_VERIFY_LOADING", true);
      return new Promise((resolve) => {
        return vm.$http.put(`group-sessions/${sessionId}/verify`).then(
          (res) => {
            commit("SET_VERIFY_LOADING", false);
            commit("SET_GROUP_SESSION", res.data.data);
            resolve(res.data?.data);
          },
          (err) => {
            commit("SET_VERIFY_LOADING", false);
            if (!err.accessDenied) {
              Swal.fire({
                title: "Error",
                text:
                  err?.data?.error?.message ||
                  err?.data?.message ||
                  "Something went wrong...",
                icon: "error",
              });
            }
            resolve(false);
          }
        );
      });
    },

    unverifySession: function ({ commit }, sessionId) {
      const vm = this;
      commit("SET_UNVERIFY_LOADING", true);
      return new Promise((resolve) => {
        return vm.$http.put(`group-sessions/${sessionId}/unverify`).then(
          (res) => {
            commit("SET_UNVERIFY_LOADING", false);
            commit("SET_GROUP_SESSION", res.data.data);
            resolve(res.data?.data);
          },
          (err) => {
            commit("SET_UNVERIFY_LOADING", false);
            if (!err.accessDenied) {
              Swal.fire({
                title: "Error",
                text:
                  err?.data?.error?.message ||
                  err?.data?.message ||
                  "Something went wrong...",
                icon: "error",
              });
            }
            resolve(false);
          }
        );
      });
    },

    updateHidden: function ({ commit }, { sessionId, isHidden }) {
      const vm = this;
      commit("SET_UPDATE_HIDDEN_LOADING", true);
      return new Promise((resolve) => {
        return vm.$http
          .put(`group-sessions/${sessionId}/update-hidden`, {
            is_hidden: isHidden,
          })
          .then(
            () => {
              commit("SET_UPDATE_HIDDEN_LOADING", false);
              resolve(true);
            },
            (err) => {
              commit("SET_UPDATE_HIDDEN_LOADING", false);
              if (!err.accessDenied) {
                Swal.fire({
                  title: "Error",
                  text:
                    err?.data?.error?.message ||
                    err?.data?.message ||
                    "Something went wrong...",
                  icon: "error",
                });
              }
              resolve(false);
            }
          );
      });
    },

    getParticipants: function ({ commit }, sessionId) {
      const vm = this;
      commit("SET_PARTICIPANTS_LOADING", true);
      return new Promise((resolve) => {
        return vm.$http.get(`group-sessions/${sessionId}/participants`).then(
          (res) => {
            commit("SET_PARTICIPANTS_DATA", res.data.data);
            commit("SET_PARTICIPANTS_LOADING", false);
            resolve(res.data.data);
          },
          (err) => {
            commit("SET_PARTICIPANTS_LOADING", false);
            if (!err.accessDenied) {
              Swal.fire({
                title: "Error",
                text:
                  err?.data?.error?.message ||
                  err?.data?.message ||
                  "Something went wrong...",
                icon: "error",
              });
            }
            resolve(false);
          }
        );
      });
    },

    addParticipants: function (
      { commit, state },
      { sessionId, userIds, isFeeRequired, sendNotification, allowOverlap }
    ) {
      const vm = this;
      commit("SET_ADD_PARTICIPANTS_LOADING", true);
      return new Promise((resolve) => {
        return vm.$http
          .post(`group-sessions/${sessionId}/participants`, {
            user_ids: userIds,
            is_fee_required: isFeeRequired,
            send_notification: sendNotification,
            allow_overlap: allowOverlap || false,
          })
          .then(
            (res) => {
              commit("SET_ADD_PARTICIPANTS_LOADING", false);
              commit("SET_PARTICIPANTS_DATA", res.data.data);
              if (sendNotification && state.groupSession) {
                commit("SET_GROUP_SESSION", {
                  ...state.groupSession,
                  has_sent_invitations: true,
                });
              }
              resolve(res.data.data);
            },
            (err) => {
              commit("SET_ADD_PARTICIPANTS_LOADING", false);
              if (!err.accessDenied) {
                Swal.fire({
                  title: "Error",
                  text:
                    err?.data?.error?.message ||
                    err?.data?.message ||
                    "Something went wrong...",
                  icon: "error",
                });
              }
              resolve(false);
            }
          );
      });
    },

    removeParticipant: function (
      { commit, dispatch },
      { sessionId, userId, sendNotification = false }
    ) {
      const vm = this;
      commit("SET_REMOVE_PARTICIPANT_LOADING", userId);
      return new Promise((resolve) => {
        return vm.$http
          .delete(
            `group-sessions/${sessionId}/participants/${userId}?send_notification=${
              sendNotification ? 1 : 0
            }`
          )
          .then(
            () => {
              commit("SET_REMOVE_PARTICIPANT_LOADING", null);
              dispatch("getParticipants", sessionId);
              resolve(true);
            },
            (err) => {
              commit("SET_REMOVE_PARTICIPANT_LOADING", null);
              if (!err.accessDenied) {
                Swal.fire({
                  title: "Error",
                  text:
                    err?.data?.error?.message ||
                    err?.data?.message ||
                    "Something went wrong...",
                  icon: "error",
                });
              }
              resolve(false);
            }
          );
      });
    },

    bulkUpdateAttendance: function (
      { commit },
      { sessionId, participants, externalAttendance }
    ) {
      const vm = this;
      commit("SET_ATTENDANCE_LOADING", true);
      const payload = { participants };
      if (
        externalAttendance !== undefined &&
        externalAttendance !== null &&
        !isNaN(externalAttendance)
      ) {
        payload.external_attendance = externalAttendance;
      }
      return new Promise((resolve) => {
        return vm.$http
          .put(`group-sessions/${sessionId}/attendance`, payload)
          .then(
            (res) => {
              commit("SET_ATTENDANCE_LOADING", false);
              commit("SET_PARTICIPANTS_DATA", res.data.data);
              resolve(res.data.data);
            },
            (err) => {
              commit("SET_ATTENDANCE_LOADING", false);
              if (!err.accessDenied) {
                Swal.fire({
                  title: "Error",
                  text:
                    err?.data?.error?.message ||
                    err?.data?.message ||
                    "Something went wrong...",
                  icon: "error",
                });
              }
              resolve(false);
            }
          );
      });
    },

    /**
     * Get providers eligible for a group session based on program's profession.
     * @param {number|null} programId - If provided, filters providers by program's profession
     */
    getEligibleProviders: function (_, programId = null) {
      const vm = this;
      let url = `group-sessions-eligible-providers`;
      if (programId) {
        url += `?program_id=${programId}`;
      }
      return new Promise((resolve) => {
        return vm.$http.get(url).then(
          (res) => {
            resolve(res.data?.data || []);
          },
          (err) => {
            if (!err.accessDenied) {
              Swal.fire({
                title: "Error",
                text:
                  err?.data?.error?.message ||
                  err?.data?.message ||
                  "Something went wrong...",
                icon: "error",
              });
            }
            resolve([]);
          }
        );
      });
    },

    /**
     * Get programs filtered by the current user's professions.
     * For providers, only returns programs matching their professions.
     * For admins/managers, returns all active programs.
     */
    getEligiblePrograms: function () {
      const vm = this;
      return new Promise((resolve) => {
        return vm.$http.get(`group-sessions-eligible-programs`).then(
          (res) => {
            resolve(res.data?.data || []);
          },
          (err) => {
            if (!err.accessDenied) {
              Swal.fire({
                title: "Error",
                text:
                  err?.data?.error?.message ||
                  err?.data?.message ||
                  "Something went wrong...",
                icon: "error",
              });
            }
            resolve([]);
          }
        );
      });
    },

    /**
     * Get clients eligible to be enrolled in a group session.
     * Filters based on session providers:
     * - Admin/Manager enrolling + admin/manager provider → all clients
     * - Admin/Manager enrolling + regular providers → clients of those providers
     * - Provider enrolling → only their own clients
     *
     * @param {number} sessionId - The group session ID
     * @param {boolean} includeEnrolled - If true, includes already enrolled participants
     */
    getEligibleParticipants: function (
      _,
      { sessionId, includeEnrolled = false }
    ) {
      const vm = this;
      let url = `group-sessions/${sessionId}/eligible-participants`;
      if (includeEnrolled) {
        url += `?include_enrolled=true`;
      }
      return new Promise((resolve) => {
        return vm.$http.get(url).then(
          (res) => {
            resolve(res.data?.data || []);
          },
          (err) => {
            if (!err.accessDenied) {
              Swal.fire({
                title: "Error",
                text:
                  err?.data?.error?.message ||
                  err?.data?.message ||
                  "Something went wrong...",
                icon: "error",
              });
            }
            resolve([]);
          }
        );
      });
    },

    /**
     * Get group sessions for calendar display.
     * Builds query from filters and returns formatted calendar events.
     *
     * @param {Object} payload - Filter options
     * @param {string} payload.start - Start date (ISO string)
     * @param {string} payload.end - End date (ISO string)
     * @param {number} payload.clientId - Filter by client (patient) ID
     * @param {number} payload.providerUserId - Filter by provider user ID
     * @param {string} payload.classIds - Filter by classification IDs
     * @param {string} payload.clientIds - Filter by multiple client IDs
     * @param {string} payload.providerIds - Filter by multiple provider IDs
     * @param {string} payload.billableStatus - Filter by billable status
     * @param {AbortSignal} payload.signal - AbortController signal for cancellation
     */
    getCalendarEvents: function (_, payload = {}) {
      const vm = this;
      const filters = [];

      // Required date range
      if (payload.start) {
        filters.push(`start=${payload.start}`);
      }
      if (payload.end) {
        filters.push(`end=${payload.end}`);
      }

      // Personal Calendar: Client's Events tab
      if (payload.clientId) {
        filters.push(`client_id=${payload.clientId}`);
      }

      // Personal Calendar: Provider's Events tab
      if (payload.providerUserId) {
        filters.push(`provider_user_id=${payload.providerUserId}`);
      }

      // Main Calendar Filters
      if (payload.classIds) {
        filters.push(`class_ids=${payload.classIds}`);
      }
      if (payload.clientIds) {
        filters.push(`client_ids=${payload.clientIds}`);
      }
      if (payload.providerIds) {
        filters.push(`provider_ids=${payload.providerIds}`);
      }
      if (payload.billableStatus) {
        filters.push(`billable_status=${payload.billableStatus}`);
      }
      if (payload.trashed) {
        filters.push(`trashed=${payload.trashed}`);
      }

      let url = `group-sessions-calendar`;
      if (filters.length) {
        url += `?${filters.join("&")}`;
      }

      const options = {};
      if (payload.signal) {
        options.signal = payload.signal;
      }

      return new Promise((resolve) => {
        return vm.$http.get(url, options).then(
          (res) => {
            resolve(res.data?.data || []);
          },
          () => {
            // Gracefully handle errors (feature might be disabled)
            resolve([]);
          }
        );
      });
    },

    /**
     * Get billing report data for frontend display
     * @param {Object} payload - Filters
     */
    getBillingReportData: function ({ commit }, payload = {}) {
      const vm = this;
      commit("SET_BILLING_REPORT_DATA_LOADING", true);
      const filters = [];
      if (payload.start) {
        filters.push(`start=${payload.start}`);
      }
      if (payload.end) {
        filters.push(`end=${payload.end}`);
      }
      if (payload.program_id) {
        filters.push(`program_id=${payload.program_id}`);
      }
      if (payload.provider_id) {
        filters.push(`provider_id=${payload.provider_id}`);
      }
      if (payload.client_id) {
        filters.push(`client_id=${payload.client_id}`);
      }
      if (payload.client_admin_id) {
        filters.push(`client_admin_id=${payload.client_admin_id}`);
      }
      if (payload.classes) {
        filters.push(`classes=${payload.classes}`);
      }
      if (payload.clinics) {
        filters.push(`clinics=${payload.clinics}`);
      }
      let url = "group-sessions/reports/billing";
      if (filters.length) {
        url += `?${filters.join("&")}`;
      }
      return new Promise((resolve) => {
        return vm.$http.get(url).then(
          (res) => {
            commit("SET_BILLING_REPORT_DATA", res.data.data);
            commit("SET_BILLING_REPORT_DATA_LOADING", false);
            resolve(res.data.data);
          },
          (err) => {
            commit("SET_BILLING_REPORT_DATA_LOADING", false);
            if (!err.accessDenied) {
              Swal.fire({
                title: "Error",
                text:
                  err?.data?.error?.message ||
                  err?.data?.message ||
                  "Failed to load billing data",
                icon: "error",
              });
            }
            resolve(false);
          }
        );
      });
    },

    /**
     * Get payroll report data for frontend display
     * @param {Object} payload - Filters
     */
    getPayrollReportData: function ({ commit }, payload = {}) {
      const vm = this;
      commit("SET_PAYROLL_REPORT_DATA_LOADING", true);
      const filters = [];
      if (payload.start) {
        filters.push(`start=${payload.start}`);
      }
      if (payload.end) {
        filters.push(`end=${payload.end}`);
      }
      if (payload.program_id) {
        filters.push(`program_id=${payload.program_id}`);
      }
      if (payload.provider_id) {
        filters.push(`provider_id=${payload.provider_id}`);
      }
      if (payload.provider_admin_id) {
        filters.push(`provider_admin_id=${payload.provider_admin_id}`);
      }
      if (payload.classes) {
        filters.push(`classes=${payload.classes}`);
      }
      if (payload.clinics) {
        filters.push(`clinics=${payload.clinics}`);
      }
      let url = "group-sessions/reports/payroll";
      if (filters.length) {
        url += `?${filters.join("&")}`;
      }
      return new Promise((resolve) => {
        return vm.$http.get(url).then(
          (res) => {
            commit("SET_PAYROLL_REPORT_DATA", res.data.data);
            commit("SET_PAYROLL_REPORT_DATA_LOADING", false);
            resolve(res.data.data);
          },
          (err) => {
            commit("SET_PAYROLL_REPORT_DATA_LOADING", false);
            if (!err.accessDenied) {
              Swal.fire({
                title: "Error",
                text:
                  err?.data?.error?.message ||
                  err?.data?.message ||
                  "Failed to load payroll data",
                icon: "error",
              });
            }
            resolve(false);
          }
        );
      });
    },

    /**
     * Get attendance report data for frontend display
     * @param {Object} payload - Filters
     */
    getAttendanceReportData: function ({ commit }, payload = {}) {
      const vm = this;
      commit("SET_ATTENDANCE_REPORT_DATA_LOADING", true);
      const filters = [];
      if (payload.start) {
        filters.push(`start=${payload.start}`);
      }
      if (payload.end) {
        filters.push(`end=${payload.end}`);
      }
      if (payload.program_id) {
        filters.push(`program_id=${payload.program_id}`);
      }
      if (payload.provider_id) {
        filters.push(`provider_id=${payload.provider_id}`);
      }
      if (payload.client_id) {
        filters.push(`client_id=${payload.client_id}`);
      }
      if (payload.client_admin_id) {
        filters.push(`client_admin_id=${payload.client_admin_id}`);
      }
      if (payload.provider_admin_id) {
        filters.push(`provider_admin_id=${payload.provider_admin_id}`);
      }
      if (payload.attendance_status) {
        filters.push(`attendance_status=${payload.attendance_status}`);
      }
      if (payload.classes) {
        filters.push(`classes=${payload.classes}`);
      }
      if (payload.clinics) {
        filters.push(`clinics=${payload.clinics}`);
      }
      let url = "group-sessions/reports/attendance";
      if (filters.length) {
        url += `?${filters.join("&")}`;
      }
      return new Promise((resolve) => {
        return vm.$http.get(url).then(
          (res) => {
            commit("SET_ATTENDANCE_REPORT_DATA", res.data.data);
            commit("SET_ATTENDANCE_REPORT_DATA_LOADING", false);
            resolve(res.data.data);
          },
          (err) => {
            commit("SET_ATTENDANCE_REPORT_DATA_LOADING", false);
            if (!err.accessDenied) {
              Swal.fire({
                title: "Error",
                text:
                  err?.data?.error?.message ||
                  err?.data?.message ||
                  "Failed to load attendance data",
                icon: "error",
              });
            }
            resolve(false);
          }
        );
      });
    },
  },
};
